import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateGroupPopupComponent, User } from '../create-group-popup/create-group-popup.component';
import { VideoSDK } from '@videosdk.live/js-sdk';
import { GroupSharingService } from '../group-sharing.service.component';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatBottomSheet, MatBottomSheetConfig } from '@angular/material/bottom-sheet';
import { EMPTY, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { CommonDialogComponent } from '../common-dialog/common-dialog.component';
import { HotToastService } from '@ngneat/hot-toast';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-group-sharing-lobby-qa',
    templateUrl: './group-sharing-lobby-qa.component.html',
    styleUrls: ['./group-sharing-lobby-qa.component.scss']
})
export class GroupSharingLobbyQAComponent implements OnInit, OnDestroy, AfterViewInit {
    meetingId: any;
    meeting: any;
    name: any;
    token: any;
    localParticipantAudio: any;
    @Input() eventId: string = '';
    joinEventDetails
    meetingStarted: boolean = false;
    customRoomId
    hostUserCustomId
    hostUserId
    eventDetails
    hostUser
    eventsList: any = [];
    userDetails: any = [];
    @ViewChild('videoContainer', { static: false }) videoContainer: ElementRef | undefined;
    users: Array<any> = Array(3).fill(1).map((n, i) => n + i); // based on array size will change
    micEnable: boolean = false;
    webCamEnable: boolean = false;
    cineJoySpotLightSchedule: any;
    isLoading: boolean = true;
    videocam_on = "assets/icons/group-sharing/videocam.svg"
    videocam_off = "assets/icons/group-sharing/videocam_off.svg"
    mic_on = "assets/icons/group-sharing/mic.svg"
    mic_off = "assets/icons/group-sharing/mic_off.svg"
    menu_icon = "assets/icons/group-sharing/more_vert.svg"
    totalParticipant: any = 0;
    filteredOptions: Observable<User[]>;
    myControl = new FormControl();
    first_video
    second_video
    isSlowMotionGraphicsLoading: boolean = false;
    cinejoyPremierDetails
    eventInterval: any;
    join_btn: boolean = false;
    panelOpenState = false;
    webcams: any = [];
    requestedForEntry: boolean = false;
    activateCounter: boolean = false;
    timeLeft: any = 180;
    interval: any;
    isSessionAvailable: boolean = false;
    selectedUsers: any;
    constructor(public dialog: MatDialog,
        public gsService: GroupSharingService,
        public spotlightService: SpotlightService,
        private router: Router,
        public bottomSheet: MatBottomSheet,
        private _snackBar: MatSnackBar,
        private toast: HotToastService, private route: ActivatedRoute) {
        this.eventId = this.route.snapshot.params.id;
    }

    ngOnInit(): void {
        if (localStorage.getItem('meetingDetails')) {
            this.eventId = JSON.parse(localStorage.getItem('meetingDetails'))?.eventId;
        }
        this.getUserDetails()
        //this.eventInterval= setInterval(()=>{
        this.getActiveParties()
        //  }, 5000)
        this.getStreamingLink()
        this.getEventDetails()
        this.getPremierInfo()
        setTimeout(() => {
            this.isLoading = false;
        }, 3000)
        this.filteredOptions = this.myControl.valueChanges.pipe(
            startWith(''),
            debounceTime(400),
            distinctUntilChanged(),
            switchMap(val => {
                return this.filter(val || '')
            })
        )
        this.gsService.subscribeToEventWatchParty(this.eventId)
        this.gsService.socketObservable.subscribe((res) => {

            if (res && res != undefined && Object.keys(res).length != 0) {
                this.getActiveParties()
                this.openSnackBarForParticipantAdded(res)
            }
        })

        let motionGraphicVideo = localStorage.getItem("motionGraphics" + this.eventId);
        if (motionGraphicVideo == 'done') {
            this.isSlowMotionGraphicsLoading = false;
            this.isLoading = true;
            this.spotlightService.setIsMotionGraphicsCompleted(true);
            setInterval(() => {
                this.isLoading = false
            }, 4000)
        } else if (motionGraphicVideo == null) {
            this.isSlowMotionGraphicsLoading = true;
            this.spotlightService.setIsMotionGraphicsCompleted(true);
            this.isLoading = false;
        }
    }

    ngAfterViewInit(): void {
        if (localStorage.getItem('meetingDetails')) {
            this.isSessionAvailable = true;
            this.spotlightService.getUserDetails().toPromise().then((res: any) => {

                //   this.firstName = (res.firstName).toUpperCase();
                this.userDetails = res;
                this.eventId = JSON.parse(localStorage.getItem('meetingDetails'))?.eventId;
                res['userId'] = res?.userID ? res.userID : res.userId
                localStorage.setItem('userData', JSON.stringify(res));
                this.gsService.getActiveWatchParty(this.eventId).subscribe((res) => {
                    let item;
                    // this.eventDetails = res;
                    const value: any = JSON.parse(localStorage.getItem('meetingDetails'));
                    if (value) {
                        this.token = value.token;
                        this.meetingId = value.meetingId;
                        this.customRoomId = value.customRoomId
                    }
                    let userDetails = JSON.parse(localStorage.getItem('userData'))
                    if (res) {
                        item = res.find((v) => v.customRoomId == this.customRoomId)
                    }
                    this.eventDetails = item;
                    this.hostUserId = item.userId
                    this.hostUserCustomId = item.userId + '-sss'
                    if (userDetails.userId === item.userId) {

                        this.hostUser = true;
                    } else {
                        this.hostUser = false;
                    }
                    this.selectedUsers = this.eventDetails.participants;
                    if (localStorage.getItem('meetingDetails')) {


                        if (value.isAdmin) {
                            setTimeout(() => {
                                this.meetingStarted = true;
                                this.startMeeting(value.token, value.meetingId)

                            }, 2000)
                        } else {
                            setTimeout(() => {
                                this.userJoinMeeting(value)
                            }, 5000)
                        }
                    }
                }, err => {

                })
            }).catch((err: any) => {

            });
        }
    }

    openDialog() {

        this.dialog.open(CreateGroupPopupComponent, {
            width: '30vw',
            height: '100%',
            panelClass: 'create-group-dialog',
            data: {
                eventId: this.eventId,
                isPreScheduleEvent: false
            },
        }).afterClosed().subscribe((res) => {

            if (res) {
                this.meetingStarted = res.startMeeting;
                //  this.isGroupShareActive.emit('true');
                this.token = res.token;
                this.meetingId = res.meetingId;
                this.customRoomId = res.customRoomId
                this.getEventDetails()
                localStorage.setItem('meetingDetails', JSON.stringify(res))
                this.startMeeting(this.token, this.meetingId)
            }

        })


    }

    async startMeeting(token: any, meetingId: any) {
        // Meeting config

        VideoSDK.config(token);

        this.meetingId = meetingId

        this.meeting = VideoSDK.initMeeting({
            meetingId: meetingId, // required
            name: (this.userDetails.firstName + ' ' + this.userDetails.lastName).toUpperCase(), // required
            micEnabled: false, // optional, default: true
            webcamEnabled: false, // optional, default: true
            maxResolution: "hd", // optional, default: "hd"
            //    token: token,
            participantId: this.userDetails.userId + '-sss'
        });
        this.meeting.join();
        this.setMeetingEvents();
        setTimeout(() => {
            this.createLocalParticipant(this.meeting)
        }, 2000)

        // this.webcams = await this.meeting?.getWebcams();
        // const { deviceId, label } = this.webcams[0]

        // this.meeting?.changeWebcam(deviceId);


    }

    createLocalParticipant(meeting: any) {

        //   this.participantId = meeting.localParticipant.id;
        const localParticipant = this.createVideoElement(meeting.localParticipant);

        this.videoContainer?.nativeElement.appendChild(localParticipant);
    }

    createVideoElement(participant: any) {

        let division;
        division = document.createElement("div");
        division.setAttribute("id", "video-frame-container");
        division.className = 'profile five-items-row'
        let videoElement = document.createElement("video");
        //videoElement.style.transform = "scale(-1,1)"
        videoElement.classList.add("video-frame");
        videoElement.setAttribute("id", `v-${participant.id}`);
        videoElement.setAttribute("playsinline", 'true');

        let optionsSpan = document.createElement('span')
        optionsSpan.className = 'vid-options-mute-icon'
        // optionsSpan.addEventListener('click', (e) => { this.toggleMic(e, participant) })
        // optionsSpan.innerHTML = ` <mat-icon id=iconaudiov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px">${participant?.micOn ? 'mic' : 'mic_off'}</mat-icon>`
        if (this.hostUser) {
            optionsSpan.addEventListener('click', (e) => { this.toggleMic(e) })
            optionsSpan.innerHTML = ` <mat-icon id=iconaudiov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px">${participant?.micOn ? 'mic' : 'mic_off'}</mat-icon>`
        } else if (this.meeting.localParticipant.id === participant.id) {
            optionsSpan.addEventListener('click', (e) => { this.toggleMic(e) })
            optionsSpan.innerHTML = ` <mat-icon id=iconaudiov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px">${participant?.micOn ? 'mic' : 'mic_off'}</mat-icon>`
        } else {
            optionsSpan.innerHTML = ` <mat-icon id=iconaudiov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="color:red;font-size: 18px;cursor: default;">${participant?.micOn ? 'mic' : 'mic_off'}</mat-icon>`
        }
        let optionsVideoSpan = document.createElement('span')
        //  optionsVideoSpan.addEventListener('click', (e) => { this.toggleWebCam(e) })
        optionsVideoSpan.className = 'vid-options-video-icon'
        if (this.hostUser) {
            optionsVideoSpan.addEventListener('click', (e) => { this.toggleWebCam(e) })
            optionsVideoSpan.innerHTML = `<mat-icon  id=iconvideov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px">${participant?.webcamOn ? 'videocam' : 'videocam_off'}</mat-icon>`
        } else if (this.meeting.localParticipant.id === participant.id) {
            optionsVideoSpan.addEventListener('click', (e) => { this.toggleWebCam(e) })
            optionsVideoSpan.innerHTML = `<mat-icon  id=iconvideov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="cursor:pointer;color:red;font-size: 18px">${participant?.webcamOn ? 'videocam' : 'videocam_off'}</mat-icon>`
        } else {
            optionsVideoSpan.innerHTML = `<mat-icon  id=iconvideov-${participant.id} role="img" class="mat-icon notranslate material-symbols-outlined material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font" style="color:red;font-size: 18px;cursor: default;">${participant?.webcamOn ? 'videocam' : 'videocam_off'}</mat-icon>`
        }
        let nameSpan = document.createElement("span");
        nameSpan.className = 'user-span-lobby';
        nameSpan.innerHTML = `${participant.displayName}`;
        division.appendChild(videoElement);
        division.appendChild(nameSpan)
        division.appendChild(optionsSpan)
        division.appendChild(optionsVideoSpan)
        return division;

    }

    setTrack(stream: any, audioElement: any, participant: any, isLocal: any) {
        if (stream.kind == "video") {
            if (isLocal) {
                ////  videoCamOff.style.display = "none";
                //  videoCamOn.style.display = "inline-block";
            }

            const mediaStream = new MediaStream();
            mediaStream.addTrack(stream.track);

            let videoElm: any = document.getElementById(`v-${participant.id}`);

            if (videoElm) {

                videoElm.srcObject = mediaStream;
                videoElm
                    .play()
                    .catch((error: any) =>
                        console.error("videoElem.current.play() failed", error)
                    );
                participant.setViewPort(videoElm.offsetWidth, videoElm.offsetHeight);
            }

        }
        if (stream.kind == "audio") {
            if (isLocal) {
                // micOff.style.display = "none";
                // micOn.style.display = "inline-block";
                return
            }
            const mediaStream = new MediaStream();
            mediaStream.addTrack(stream.track);
            audioElement.srcObject = mediaStream;
            audioElement
                .play()
                .catch();
        }

    }

    setMeetingEvents() {
        this.meeting.disableWebcam()
        this.meeting.muteMic()
        this.meeting.localParticipant.on("stream-enabled", (stream: any) => {
            if (stream.kind === "video") {
                this.setTrack(
                    stream,
                    this.localParticipantAudio,
                    this.meeting.localParticipant,
                    true
                );
                let toggleIcon = document.getElementById(`iconvideov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'videocam';
                this.webCamEnable = true
            }
            if (stream.kind == "audio") {
                let toggleIcon = document.getElementById(`iconaudiov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'mic';
                this.micEnable = true;
            }
        });

        this.meeting.localParticipant.on("stream-disabled", (stream: any) => {
            if (stream.kind === "video") {
                let toggleIcon = document.getElementById(`iconvideov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'videocam_off';
                this.webCamEnable = false;
            }
            if (stream.kind == "audio") {
                let toggleIcon = document.getElementById(`iconaudiov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'mic_off';
                this.micEnable = false;
            }
        });

        this.meeting.on("participant-joined", (participant) => {
            let audioElement;
            let videoElement = this.createVideoElement(participant);
            this.totalParticipant++;

            if (this.meeting.localParticipant.id !== participant.id) {
                audioElement = this.createAudioElement(participant.id);
                audioElement.style['display'] = 'none'
            }

            participant.on("stream-enabled", (stream) => {
                if (stream.kind === "video") {
                    let toggleIcon = document.getElementById(`iconvideov-${participant.id}`);
                    toggleIcon.innerHTML = 'videocam';
                }
                if (stream.kind == "audio") {
                    let toggleIcon = document.getElementById(`iconaudiov-${participant.id}`);
                    toggleIcon.innerHTML = 'mic';
                }
                this.setTrack(stream, audioElement, participant, false);
            });

            participant.on("stream-disabled", (stream) => {
                if (stream.kind === "video") {
                    let toggleIcon = document.getElementById(`iconvideov-${participant.id}`);
                    toggleIcon.innerHTML = 'videocam_off';
                }
                if (stream.kind == "audio") {
                    let toggleIcon = document.getElementById(`iconaudiov-${participant.id}`);
                    toggleIcon.innerHTML = 'mic_off';
                }
            });
            this.videoContainer.nativeElement.appendChild(videoElement);
            this.videoContainer.nativeElement.appendChild(audioElement);
        });

        this.meeting.on("entry-requested", (data) => {
            const { participantId, name, allow, deny } = data;
            //allow()
            if (localStorage.getItem('meetingDetails')) {
                allow()
            } else {

                const toastRef = this.toast.show(CommonDialogComponent, {
                    data: {
                        fact: `${data.name} is requesting to join do you wish them to be part of this group?`,
                        joinScreen: true
                    },
                    autoClose: false,
                    theme: 'snackbar',
                    position: 'top-right'
                });
                toastRef.afterClosed.subscribe((e) => {

                    if (e.dismissedByAction) {
                        // callback function to accept the request
                        allow();
                    } else {

                        // callback function to reject the request
                        deny();
                    }
                });
            }

            //



        });

        this.meeting.on("webcam-requested", ({ accept, reject }) => {
            if (localStorage.getItem('meetingDetails')) {
                accept();
            } else {
                const toastRef = this.toast.show(CommonDialogComponent, {
                    data: {
                        fact: 'Host is requesting for Web-cam',
                        joinScreen: false
                    },
                    style: {
                        width: '300px'
                    },
                    autoClose: true,
                    theme: 'snackbar',
                    position: 'top-right',
                    duration: 5000
                });
                toastRef.afterClosed.subscribe((e) => {

                    if (e.dismissedByAction) {

                        // callback function to accept the request
                        accept();

                    } else {

                        // callback function to reject the request
                        reject();
                    }
                });
            }
        });

        this.meeting.on("mic-requested", ({ accept, reject }) => {
            const toastRef = this.toast.show(CommonDialogComponent, {
                data: {
                    fact: 'Host is requesting you to unmute',
                    joinScreen: false
                },
                style: {
                    width: '300px'
                },
                autoClose: true,
                theme: 'snackbar',
                position: 'top-right',
                duration: 5000,

            });
            toastRef.afterClosed.subscribe((e) => {

                if (e.dismissedByAction) {
                    // callback function to accept the request
                    accept();
                } else {
                    // callback function to reject the request
                    reject();
                }
            });
        });

        this.meeting.on("participant-left", (participant) => {
            this.totalParticipant--;
            this.requestedForEntry = false;
            this.dialog.closeAll()
            this.bottomSheet.dismiss()
            this.toast.show(`${participant.displayName} has left the meeting`, {
                theme: 'snackbar',
                position: 'top-right'
            })
            let vElement = document.getElementById(`v-${participant.id}`);

            vElement.remove();

            let aElement = document.getElementById(`a-${participant.id}`);

            aElement.parentNode.removeChild(aElement);

            //remove it from participant list participantId;
            document.getElementById(`p-${participant.id}`)?.remove();
        });

        this.meeting.on("entry-responded", (participantId, decision) => {
            if (this.meeting?.localParticipant?.id === participantId) {
                if (decision === "allowed") {
                    // entry allowed
                    this.meetingStarted = true;
                } else {
                    // entry denied
                    this.leaveMeeting();
                    this.toast.show(`Admin has denied you to be part of this group`, {
                        theme: 'snackbar',
                        position: 'top-right'
                    })
                    this.join_btn = false;
                    //   this.openSnackBar('Admin has denied you to be part of this group', '')
                }
            }

        });

        this.meeting.on("meeting-left", () => {
            this.meetingStarted = false;
            this.isSessionAvailable = false;
            this.requestedForEntry = false;
            this.totalParticipant--
            this.meeting.disableWebcam()
            this.meeting.muteMic()
        });

        this.meeting.on("meeting-joined", () => {
            this.totalParticipant++;
            this.meeting.disableWebcam()
        this.meeting.muteMic()
        });
    }

    createAudioElement(pId: any) {
        if (pId == this.meeting.localParticipant.id) {
            return null;
        }
        let audioElement = document.createElement("audio");
        audioElement.setAttribute("autoPlay", "false");
        audioElement.setAttribute("playsInline", "true");
        audioElement.setAttribute("controls", "false");
        audioElement.setAttribute('muted', 'true')
        audioElement.setAttribute("id", `a-${pId}`);
        return audioElement;
    }

    userJoinMeeting(event) {

        this.token = event.token;
        this.meetingId = event.roomId;
        this.eventId = event.eventId;
        this.joinEventDetails = event;
        this.meetingStarted = true;
        this.customRoomId = event.customRoomId
        // this.isGroupShareActive.emit(event)
        this.startMeeting(this.token, this.meetingId)
        this.toast.show(`Requested Host to let you in!`, {
            theme: 'snackbar',
            position: 'top-right',
            duration: 5000
        })
        this.getEventDetails()
    }

    getEventDetails() {
        // this.eventDetails=[]
        this.gsService.getActiveWatchParty(this.eventId).subscribe((res) => {
            let item;
            // this.eventDetails = res;

            let userDetails = JSON.parse(localStorage.getItem('userData'))
            let meetingDetails = JSON.parse(localStorage.getItem('meetingDetails'))
            if (res) {
                item = res.find((v) => v.customRoomId == this.customRoomId)
            }
            if (item) {
                this.selectedUsers = item.participants;
                this.eventDetails = item;
                this.hostUserId = item.userId;
                this.hostUserCustomId = item.userId + '-sss'
                if (userDetails.userId === item.userId) {

                    this.hostUser = true;
                } else {
                    this.hostUser = false;
                }
            }



        }, err => {

        })
    }

    joinGroupEvent(item) {

        if (!this.requestedForEntry) {
            this.requestedForEntry = true;
            navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
                this.meetingId = item.roomId;
                this.getParticipantToken(item);
            }).catch((err) => {

            });
        } else {
            this.toast.show(`Please Wait untill host lets you in!`, {
                theme: 'snackbar',
                position: 'top-right',
                duration: 5000
            })
        }


        // this.joinGroup()
    }

    getParticipantToken(item) {
        this.gsService.getParticipantToken(this.eventId, item.customRoomId).subscribe((res) => {

            //this.eventsList = res;
            // clearInterval(this.eventInterval)
            this.userJoinMeeting({ token: res.token, roomId: this.meetingId, eventId: this.eventId, customRoomId: item.customRoomId })
            //  this.token.emit({ token: res.token, roomId: this.meetingId, eventId: this.eventId, customRoomId: item.customRoomId });
        }, err => {

        })
    }
    exsistingGroup: boolean = false;
    getActiveParties() {
        this.eventsList = []

        this.gsService.getActiveWatchParty(this.eventId).subscribe((res) => {

            let item: any = '';
            if (localStorage.getItem('userData')) {
                item = JSON.parse(localStorage.getItem('userData'))
            }
            res.forEach(element => {
                // if(item.userId !== element.userId){
                if (element.participants.find((v) => v.userId === item.userId)) {
                    this.eventsList.push(element)
                }
                // }

            });
            if (res.filter((v) => v.userId == item.userId).length > 0) {
                this.eventDetails = res.filter((v) => v.userId == item.userId)[0];
                this.exsistingGroup = true;
            } else {
                this.exsistingGroup = false;
            }

            //this.getParticipantToken();
        }, err => {

        })
    }

    joinExsistingGroup() {
        if (this.canUserAccessMovie) {
            if (document.getElementById('startGrpBtn')) {
                document.getElementById('startGrpBtn').setAttribute('disabled', 'true')
                setTimeout(() => {
                    document.getElementById('startGrpBtn').setAttribute('disabled', 'false')
                }, 4000)
            }
            navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
                this.getHostToken()
            }).catch((err) => {
                console.error(`you got an error: ${err}`)
                this.openSnackBar('Please allow Camera and Microphone to start the group sharing on spotlight.', '')
            });
        } else {
            this.toast.show(`${this.message}`, {
                theme: 'snackbar',
                position: 'top-right',
                duration: 5000
            })
        }


    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 5000,
            horizontalPosition: 'end',
            verticalPosition: 'top'
        });
    }

    getHostToken() {
        this.gsService.getHostToken(this.eventDetails.eventId, this.eventDetails.customRoomId).subscribe((res) => {
            res.startMeeting = true;
            res.entryRequested = false;
            res.meetingId = this.eventDetails.roomId,
                res.eventId = this.eventDetails.eventId,
                res.customRoomId = this.eventDetails.customRoomId,
                this.customRoomId = this.eventDetails.customRoomId
            this.token = res.token
            this.meetingId = this.eventDetails.roomId
            this.eventId = this.eventDetails.eventId
            res.isMeetingJoined = true
            this.meetingStarted = res.startMeeting;
            res.isAdmin = true;
            this.getEventDetails()
            localStorage.setItem('meetingDetails', JSON.stringify(res))
            this.startMeeting(res.token, this.eventDetails.roomId)
        }, err => {

        })
    }

    getUserDetails() {
        this.spotlightService.getUserDetails().toPromise().then((res: any) => {

            //   this.firstName = (res.firstName).toUpperCase();
            this.userDetails = res;
            res['userId'] = res.userID ? res.userID : res.userId
            localStorage.setItem('userData', JSON.stringify(res));

        }).catch((err: any) => {

        });
    }

    async toggleMic(event?: Event, item?: any) {
        let toggleIcon2: any = document.getElementById('listLocalAudio');
        let elementId: string = (event?.target as Element).id;
        if (elementId === 'listLocalAudio' || elementId.split('-')[1] == this.meeting.localParticipant.id.split('-')[0]) {
            if (this.micEnable) {
                let toggleIcon = document.getElementById(`iconaudiov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'mic_off';
                if (toggleIcon2 != null) {
                    toggleIcon2.src = this.mic_off
                }
                this.micEnable = false;
                this.meeting?.muteMic();
            } else {
                let toggleIcon = document.getElementById(`iconaudiov-${this.meeting.localParticipant.id}`);
                toggleIcon.innerHTML = 'mic';
                this.micEnable = true;
                if (toggleIcon2 != null) {
                    toggleIcon2.src = this.mic_on;
                }
                let customAudioTrack = await VideoSDK.createMicrophoneAudioTrack({
                    encoderConfig: "high_quality",
                    noiseConfig: {
                        noiseSuppression: true,
                        echoCancellation: true,
                        autoGainControl: true,
                    },
                    microphoneId: ''
                });
                this.meeting?.unmuteMic(customAudioTrack);
            }
        } else {
            const participants = this.meeting.participants;
            let participant;
            if (participants.get(elementId.replace('iconaudiov-', ''))) {
                participant = participants.get(elementId.replace('iconaudiov-', ''));
            } else {
                participant = participants.get(elementId.replace('listmic-', ''));
            }
            let toggleIcon = document.getElementById(`iconaudiov-${participant.id}`);

            if (participant?.micOn) {
                //  toggleIcon.innerHTML = 'mic_off';
                // This will directly disable webcam of particular participant
                participant.disableMic();
            } else {
                //  toggleIcon.innerHTML = 'mic';
                participant.enableMic();
            }
        }

    }

    async toggleWebCam(event?: Event) {
        let toggleIcon1: any = document.getElementById('listLocalVideo');
        let elementId: string = (event?.target as Element).id;
        if (elementId === 'listLocalVideo' || elementId.split('-')[1] == this.meeting.localParticipant.id.split('-')[0]) {
            let toggleIcon = document.getElementById(`iconvideov-${this.meeting.localParticipant.id}`);
            if (this.webCamEnable) {
                this.webCamEnable = false;
                toggleIcon.innerHTML = 'videocam_off';
                if (toggleIcon1 != null) {
                    toggleIcon1.src = this.videocam_off
                }
                this.meeting?.disableWebcam();
            } else {
                this.webCamEnable = true;
                toggleIcon.innerHTML = 'videocam';
                if (toggleIcon1 != null) {
                    toggleIcon1.src = this.videocam_on
                }
                this.meeting?.enableWebcam();
            }
        } else {
            const participants = this.meeting.participants;

            let participant;
            if (participants.get(elementId.replace('iconvideov-', ''))) {
                participant = participants.get(elementId.replace('iconvideov-', ''));

            } else {
                participant = participants.get(elementId.replace('listvideo-', ''));
            }
            let toggleIcon = document.getElementById(`iconvideov-${participant.id}`);
            if (participant?.webcamOn) {
                //   toggleIcon.innerHTML = 'videocam_off';
                participant.disableWebcam();
            } else {
                // toggleIcon.innerHTML = 'videocam';
                participant.enableWebcam();
            }
        }
    }
    premierInterval: any;

    getPremierInfo() {

        this.spotlightService.getPremierdeatails(this.eventId).toPromise().then((responseData: any) => {

            this.cinejoyPremierDetails = responseData
            this.cineJoySpotLightSchedule = responseData.cinejoySpotlightsSchedule;
            const groupSharingSchedule = this.cineJoySpotLightSchedule.find((x: any) => x.scheduleMainText === 'GS2')
            const endOfFestivesSchedule = this.cineJoySpotLightSchedule.filter((x: any) => x.scheduleMainText === 'End of Festivities');
            const redCarpetURL = 'cinejoy/premiere/redcarpet/' + responseData.eventId + '/' + responseData.name.replaceAll(' ', '-');
            const theaterURL = 'cinejoy/premiere/theater/' + this.cinejoyPremierDetails.eventId;
            this.first_video = responseData.motionGraphic[0].firstVideo;
            this.second_video = responseData.motionGraphic[0].secondVideo;
            /*if (!this.spotlightService.getIsMotionGraphicsCompleted()) {
                this.isSlowMotionGraphicsLoading = true;
                this.isLoading = false;
                this.spotlightService.setIsMotionGraphicsCompleted(true);
            } else {
                this.isSlowMotionGraphicsLoading = false;
                this.isLoading = true;
            }*/

            this.premierInterval = setInterval(() => {
                const currentTimeText = Date.now();
                const currentTimeText1 = new Date()
                const endTime = new Date(endOfFestivesSchedule[0].scheduleTimeText)
                if (moment(endOfFestivesSchedule[0].scheduleTimeText).subtract(3, 'minutes') <= moment(currentTimeText)) {
                    this.activateCounter = true;
                    let diff = endTime.getTime() - currentTimeText1.getTime()
                    var seconds = diff / 1000;
                    if (this.timeLeft > 0) {
                        this.timeLeft = seconds.toFixed(0)
                    } else {
                        this.timeLeft = 180;
                    }
                }
                if (endOfFestivesSchedule[0].scheduleTimeText <= currentTimeText) {
                    this.meeting?.leave();
                    this.dialog.closeAll()
                    this.requestedForEntry = false;
                    this.router.navigate([theaterURL])
                }
            }, 1000)
        }, err => {

        })
    }

    getRedCarpetIndex(): number {
        let i = 0;
        for (const schedule of this.cineJoySpotLightSchedule) {
            if (schedule.scheduleMainText === 'Red Carpet') {
                break;
            }
            i++;
        }
        return i;
    }

    durationVideoTime(graphicsT: boolean): void {
        this.isLoading = true;
        this.startRedCarpetpagecounter(graphicsT);
    }

    startRedCarpetpagecounter(graphicsT?: boolean): void {

        const interval = setInterval(() => {
            const currentTimeText = new Date().getTime();
            if (graphicsT === true) {
                this.isSlowMotionGraphicsLoading = false;
                setTimeout(() => {
                    this.isLoading = false;
                }, 4000);
            }
            //  const currentTimeText = Date.now();
            const groupSharingSchedule = this.cineJoySpotLightSchedule.find((x: any) => x.scheduleMainText === 'GS1')
            const redCarpetSchedule = this.cineJoySpotLightSchedule.filter((x: any) => x.scheduleMainText === 'Red Carpet');
            const redCarpetURL = 'cinejoy/premiere/redcarpet/' + this.cinejoyPremierDetails.eventId + '/' + this.cinejoyPremierDetails.name.replaceAll(' ', '-');
            if ((redCarpetSchedule[0].scheduleTimeText <= currentTimeText) && (this.cineJoySpotLightSchedule[this.getRedCarpetIndex() + 1].scheduleTimeText >= currentTimeText)) {
                clearInterval(interval);
                this.bottomsheetModel.dismiss()
                this.meeting.leave();
                this.router.navigate([redCarpetURL])
            }
        }, 3000);
    }

    leaveMeeting() {
        this.totalParticipant = 0;
        this.join_btn = false;
        this.meeting.disableWebcam()
        this.meeting.muteMic()
        this.meeting?.leave();
        this.getActiveParties();
        if (this.hostUser) {
            this.hostUser = false;
        }
        this.requestedForEntry = false;
        this.isSessionAvailable = false;
        localStorage.removeItem('meetingDetails')
        this.meetingStarted = false;
    }

    closeBottomSheet() {
        this.bottomSheet.dismiss();
    }

    getDisplayName(item) {
        return item.value;
    }

    getControlValue(value: string, controlValue: any) {
        if (value === 'mic') {
            return `listmic-${controlValue.value.id}`
        } else {
            return `listvideo-${controlValue.value.id}`
        }
    }

    removeParticipant(item) {
        let participantId = item.key.replace('sss', "")
        this.meeting.participants.get(item.key).remove()
        this.bottomSheet.dismiss();
        this.dialog.closeAll()
        this.requestedForEntry = false;
        let obj = {
            "partyType": "PRIVATE",
            "customRoomId": this.customRoomId,
            "eventId": this.eventId,
            "userIds": [
                participantId
            ]
        }
        this.gsService.removeParticipants(obj).subscribe((res) => {
            // this.bottomSheet.dismiss()
        }, err => {

        })
    }

    getIsUserHost(item) {
        if (item?.id === this.hostUserCustomId || item?.key === this.hostUserCustomId) {
            return true

        } else {
            return false
        }
    }

    addParticipantsToExsistingEvent(userId) {
        let item = JSON.parse(localStorage.getItem('userData'))
        if (this.selectedUsers.find((p) => p.userId == userId) || userId === this.hostUserId) {
            this.toast.show(`Participant has been already added in to this group.`, {
                theme: 'snackbar',
                position: 'top-right',
                duration: 5000
            })
            return null;
        }


        const obj = {
            "partyType": "PRIVATE",
            "customRoomId": this.customRoomId,
            "eventId": this.eventId,
            "userIds": [
                userId
            ]
        }
        this.gsService.addParticipantToExisitingEvent(obj).subscribe((res) => {
            this.filteredOptions = this.myControl.valueChanges.pipe(
                startWith(''),
                debounceTime(400),
                distinctUntilChanged(),
                switchMap(val => {
                    return this.filter(val || '')
                })
            )
        }, err => {
            this.filteredOptions = this.myControl.valueChanges.pipe(
                startWith(''),
                debounceTime(400),
                distinctUntilChanged(),
                switchMap(val => {
                    return this.filter(val || '')
                })
            )
        })
    }

    filter(val: string): Observable<any[]> {
        // call the service which makes the http-request
        if (val.length > 3) {
            return this.gsService.getPublicUsersList(val)
                .pipe(
                    map(response => response.filter(option => {
                        let item: any = ''
                        if (localStorage.getItem('userData')) {
                            item = JSON.parse(localStorage.getItem('userData'))
                        }
                        return (option.userId != item.userID && !this.eventDetails.participants.find((p) => p.userId == option.userId))
                    }))
                )
        }
        return EMPTY;

    }
    @ViewChild('participantList') participantListTemplate: TemplateRef<any>;
    bottomsheetModel: any;
    openParticipantTemplate(config?: MatBottomSheetConfig) {
        //config.panelClass = 'cus-participant-template'

        this.bottomsheetModel = this.bottomSheet.open(this.participantListTemplate, config)

        this.bottomsheetModel.afterOpened().subscribe((res) => {

            let toggleIcon1: any = document.getElementById('listLocalVideo');
            let toggleIcon2: any = document.getElementById('listLocalAudio');
            if (this.webCamEnable) {
                if (toggleIcon1) {
                    toggleIcon1.src = this.videocam_on;
                }
            } else {
                if (toggleIcon1) {
                    toggleIcon1.src = this.videocam_off;
                }
            }
            if (this.micEnable) {
                if (toggleIcon1) {
                    toggleIcon2.src = this.mic_on;
                }
            } else {
                if (toggleIcon1) {
                    toggleIcon2.src = this.mic_off;
                }
            }

        })
        return this.bottomsheetModel;
    }

    openSnackBarForParticipantAdded(message) {
        const toastRef = this.toast.show(CommonDialogComponent, {
            data: {
                fact: `You have been invited to ${message.description} by  ${message.hostFirstName}`,
                joinScreen: false
            },
            style: {
                width: '300px'
            },
            autoClose: true,
            theme: 'snackbar',
            position: 'top-right',
            //  duration: 5000,

        });
        toastRef.afterClosed.subscribe((e) => {
            if (e.dismissedByAction) {
                // callback function to accept the request
                //    this.gsService.joinFromInvite$.next({ eventId: this.gsService.socketMessages.eventId, customRoomId: this.gsService.socketMessages.customRoomId })
            } else {

                // callback function to reject the request
            }
        });
    }

    ngOnDestroy(): void {
        this.meeting.disableWebcam()
        this.meeting.muteMic()
        this.leaveMeeting()
        this.bottomSheet.dismiss()
        this.dialog.closeAll()
        localStorage.removeItem('meetingDetails')
        this.isSessionAvailable = false;
        // this.gsService.socketObservable.unsubscribe()

    }

    changeWebcam(id: any) {
        const { deviceId, label } = this.webcams.filter((v) => v.deviceId === id);

        this.meeting?.changeWebcam(deviceId);
    }

    canUserAccessMovie
    message
    getStreamingLink(): void {
        this.spotlightService.getAgilitixStreamingLink(this.eventId).subscribe((response) => {
            if (response.Error !== undefined) {
                // TODO: message pending
                //   this.streamLink = 'https://player.vimeo.com/video/516347937?quality=1080p';
                // this.canUserAccessMovie = true;
                this.canUserAccessMovie = false;
                this.message = response.Error;
            } else if (response.AccessStatus === 'AccessValid') {
                // this.streamLink = 'https://vimeo.com/showcase/' + response.StreamingID + '/embed';
                // const url = 'https://vimeo.com/showcase/' + response.StreamingID + '/embed';
                //  this.streamLink = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
                this.canUserAccessMovie = true;
            } else if (response.AccessStatus === 'BeforeEvent') {
                this.canUserAccessMovie = false;
                this.message = 'Movie Viewing to occur 4-14 November 2021';
            } else if (response.AccessStatus === 'AccessExpired') {
                this.canUserAccessMovie = false;
                this.message = 'Your access to this movie is expired. Please purchase the movie again.';
            }
        }, (error: any) => {
            this.canUserAccessMovie = false;
            this.message = 'You do not have access to the movie.';
        });
    }
}
